<template>
  <div class="row teach-count">
    <div class="col">
      <div class="row mb-3">
        <div class="col">
          <div class="flex-between flex-align-center">
            <div class="flex">
              <el-button type="primary" size="small" @click="exportTable">导出表格</el-button>
              <div class="flex">
                <el-input
                  v-model="keyword"
                  placeholder="搜索关键字"
                  @change="handleKeyword"
                ></el-input>
                <el-button class="search-btn" type="primary" @click="handleKeyword">
                  <i class="mdi mdi-magnify"></i>
                </el-button>
              </div>
            </div>
            <div class="data-range">统计范围：{{ countArea }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <el-table
            id="teach-count-table"
            :data="teachData"
            row-key="id"
            default-expand-all
            :tree-props="{ children: 'children' }"
          >
            <el-table-column prop="title" label="活动名称">
              <template slot-scope="scope">
                <!-- <span v-if="scope.row.isTheme">{{ scope.row.name }}</span>
                <span v-if="scope.row.isSubTheme">&nbsp;{{ scope.row.name }}</span>
                <el-link class="operative" v-if="scope.row.isActivity" @click="courseActivity(scope.row)">
                  &nbsp;&nbsp;{{ scope.row.name }}
                </el-link> -->
                <span v-if="scope.row.type === 1">{{ scope.row.title }}</span>
                <el-link
                  class="operative"
                  v-else-if="scope.row.type === 2"
                  @click="courseActivity(scope.row)"
                >
                  &nbsp;&nbsp;{{ scope.row.title }}
                </el-link>
              </template>
            </el-table-column>
            <el-table-column prop="module" label="活动类型"></el-table-column>
            <el-table-column prop="finish_setting" label="活动完成条件">
              <template slot-scope="scope">
                <div v-html="scope.row.finish_setting"></div>
              </template>
            </el-table-column>
            <el-table-column prop="finish_rate">
              <template slot="header">
                <span>活动完成率</span>
                <el-tooltip class="item" effect="light" placement="top">
                  <div slot="content">活动完成率的准确性基</div>
                  <div slot="content">于活动完成条件的设置</div>
                  <i class="mdi mdi-help-circle-outline"></i>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="access_num" label="活动访问数"></el-table-column>
            <el-table-column width="300" label="操作">
              <template v-if="scope.row.type === 2" slot-scope="scope">
                <span>/</span>
                <!-- <span class="operative" @click="set(scope.row, 1)">设置完成条件</span>
                <span class="operative" @click="set(scope.row, 2)">重新统计完成</span>
                <span class="operative" @click="set(scope.row, 3)">消息提醒</span> -->
              </template>
            </el-table-column>
          </el-table>
          <el-dialog :title="completeDialogTitle" :visible.sync="completeDialogVisible" width="30%">
            <span>{{ completeDialogContent }}</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="completeDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { domainName } from '@/config/setting.js'

export default {
  data() {
    return {
      keyword: '',
      // 教学统计活动操作
      completeDialogTitle: '提示',
      completeDialogContent: '是否强制完成',
      completeDialogVisible: false,
      // 教学统计
      teachData: [],
    }
  },
  mounted() {
    this.getActStatApi()
  },
  computed: {
    countArea() {
      return (
        this.$store.state.course.courseInfo.statistics_start_time.split('-').join('.') +
        '-' +
        this.$store.state.course.courseInfo.statistics_end_time.split('-').join('.')
      )
    },
  },
  methods: {
    // 获取教学统计数据接口/下载表格接口
    async getActStatApi(type = '') {
      await this.$store
        .dispatch('course/getActStat', {
          course_id: Number(this.$route.query.courseId),
          keyword: this.keyword,
          print: type === 'download' ? 1 : 0,
          responseType: type === 'download' ? 'blob' : '',
        })
        .then(res => {
          if (type === 'download') {
            const link = document.createElement('a') // 创建a标签
            let blob = new Blob([res], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
            }) //文件流处理
            link.style.display = 'none' //去除a标签的样式
            // 设置连接
            link.href = URL.createObjectURL(blob)
            link.download = '教学统计'
            document.body.appendChild(link)
            //模拟点击事件
            link.click()
            //移除创建的a标签
            window.URL.revokeObjectURL(link.href)
            document.body.removeChild(link)
          } else if (res.code === 1) {
            console.log('res:', res)
            this.teachData = res.data
            console.log('teacheData', this.teachData)
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 课程活动跳转
    courseActivity(row) {
      this.$router.push({
        path: '/courseDetail/teachCount/courseActivity',
        query: {
          courseId: this.$route.query.courseId,
          activityId: row.cm_id,
          // title: row.title,
          // finish: row.finish_setting,
        },
      })
    },
    // 查询事件处理
    handleKeyword() {
      this.getActStatApi()
    },
    set(row, type) {
      if (type === 1) {
        console.log(row)
        window.open(domainName + '/course/modedit.php?update=' + row.cm_id, '_blank')
      } else if (type === 2) {
        console.log(row)
      } else if (type === 3) {
        console.log(row)
      }
    },
    // 导出表格
    exportTable() {
      this.getActStatApi('download')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-input {
    .el-input__inner {
      border-radius: 3px;
    }
  }
  .search-btn.el-button.el-button--primary {
    width: 56px;
    height: 40px;
    padding: 11px;
    border-radius: 3px;
  }
}
.mdi.mdi-magnify {
  font-size: 22px;
  line-height: 18px;
}
.teach-count {
  ::v-deep .el-table {
    thead {
      th.el-table__cell {
        background-color: #f5f7fa;
      }
    }
    .cell {
      color: #6c757d;
    }
  }
}
.operative {
  color: #409eff;
  margin-right: 1rem;
  cursor: pointer;
}
.data-range {
  font-size: 14px;
  color: #6c757d;
  line-height: 19px;
}
.el-button {
  margin-right: 16px;
}
</style>
